/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextAlignCenterIcon20Regular = forwardRef('TextAlignCenterIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3 3.25a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5H3Z" }),
        React.createElement("path", { d: "M5.25 8A.75.75 0 0 1 6 7.25h8a.75.75 0 0 1 0 1.5H6A.75.75 0 0 1 5.25 8Z" }),
        React.createElement("path", { d: "M3 11.25a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5H3Z" }),
        React.createElement("path", { d: "M6 15.25a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5H6Z" })));
});
